export default __webpack_public_path__ + "static/eks-prometheus-dashboard-8e1db190cdb2d684e9dd5568b0b8c401.png";